import imagesLoaded from 'imagesloaded';

function handleImageTransition(fader, slides, step) {
	if (slides && (slides.length > 0)) {
		slides.forEach((slide, i) => {
			if (i === step) {
				slide.classList.add('pbsm-image-fader__slide--active');
			} else {
				slide.classList.remove('pbsm-image-fader__slide--active');
			}
		});
	}
}

export function initImageFader(fader, timeout = 5000) {
	if (fader) {
		imagesLoaded(fader, { background: true }, () => {
			const dataAttr = fader.getAttribute('data-image-fader');
			const { backgroundImage } = fader.style;
			const backgroundImageParsed = backgroundImage.match(/\((.*?)\)/)[1].replace(/('|")/g,'');
			if (dataAttr) {
				const images = JSON.parse(dataAttr);
				if (images && (images.length > 0)) {
					if (backgroundImageParsed) {
						if (images.indexOf(backgroundImageParsed) === -1) {
							images.push(backgroundImageParsed);
						}
					}
					let slides = [];
					images.forEach((image, imageIndex) => {
						const slide = document.createElement('DIV');
						slide.classList.add('pbsm-image-fader__slide');
						slide.style.backgroundImage = `url(${image})`;
						fader.appendChild(slide);
						slides.push(slide);
					});
					let step = 0;
					let totalLoops = 0;
					setInterval(() => {
						if (totalLoops === 0) {
							setTimeout(() => {
								fader.style.backgroundImage = null;
							}, (timeout / 2));
						}
						handleImageTransition(fader, slides, step); 
						if (step < (images.length - 1)) {
							step++;
						} else {
							step = 0;
						}
						totalLoops++;
					}, timeout);
				}
			}
		});
	}
}

export function initImageFaders(timeout = 5000) {
	const faders = document.querySelectorAll('.pbsm-image-fader');
	if (faders && (faders.length > 0)) {
		faders.forEach((fader, i) => {
			initImageFader(fader, timeout);
		});
	}
}
